import axios from "axios";
import { TreeList } from "devextreme-react";
import { SimpleItem } from "devextreme-react/form";
import {
  AsyncRule,
  Button,
  Column,
  Editing,
  Form,
  Item,
  Lookup,
  Popup,
  RequiredRule,
  Scrolling,
  Selection,
  StateStoring,
  StringLengthRule,
  Texts,
  Toolbar,
} from "devextreme-react/tree-list";
import CustomStore from "devextreme/data/custom_store";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { div } from "./data";
import { hasPermission } from "../../../utils/hasPermission";
import { PERM } from "../../../utils/permissions";

export default function DivisionList(props) {
  const {
    employeeDataGridRef,
    // employeeTileViewRef /*, divDataSource, setDivDataSource*/,
  } = props;

  // const [dataSource, setDataSource] = useState(null);
  const [editRowKey, setEditRowKey] = useState(null);
  const [divDataSource, setDivDataSource] = useState(null);

  const userInfo = useSelector((state) => state.userInfo);
  const canEditDiv = hasPermission(userInfo.permissions, PERM.ORG_DIV_EDIT);

  useEffect(() => {
    // setDataSource(
    setDivDataSource(
      new CustomStore({
        key: "div",
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/employee/div?includeBCC=true`
          );

          return result.data;
        },
        insert: async (values) => {
          await axios.post(
            `${process.env.REACT_APP_BECCO_API_URL}/api/employee/div`,
            values
          );
        },
        update: async (key, values) => {
          await axios.put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/employee/div/${key}`,
            values
          );

          setEditRowKey(null);
        },
        remove: async (key) => {
          const result = await axios.delete(
            `${process.env.REACT_APP_BECCO_API_URL}/api/employee/div/${key}`
          );
        },
        errorHandler: (error) => {
          error.message = `해당 Division에 소속된 Employee가 있습니다. Division 삭제가 불가합니다.`;
        },
      })
    );
  }, []);

  const onSelectionChanged = ({ selectedRowsData }) => {
    if (selectedRowsData.length > 0) {
      if (selectedRowsData[0].div != "BCC") {
        employeeDataGridRef.current.instance.clearSelection();
        employeeDataGridRef.current.instance.filter([
          ["div", "=", selectedRowsData[0].div],
          "or",
          ["uDiv", "=", selectedRowsData[0].div],
        ]);

        // employeeTileViewRef.current.instance
        //   .getDataSource()
        //   .filter(["div", "=", selectedRowsData[0].div], "or", [
        //     "uDiv",
        //     "=",
        //     selectedRowsData[0].div,
        //   ]);
      } else {
        employeeDataGridRef.current.instance.clearFilter();

        // employeeTileViewRef.current.instance.getDataSource().filter(null);
      }

      // employeeTileViewRef.current.instance.getDataSource().load();

      const width =
        // employeeTileViewRef.current.instance.getDataSource().totalCount() *
        100 + 200;

      // employeeTileViewRef.current.instance.option(
      //   "width",
      //   width > 1000 ? 1000 : width
      // );
    }
    // employeeDataGridRef.current.instance.selectRowsByIndexes([0]);
  };

  const validationCallback = async (params) => {
    if (!editRowKey || editRowKey != params.value) {
      const result = await axios.get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/employee/hasDiv/${params.value}`
      );

      return result.data.nDiv == 0;
    } else {
      return true;
    }
  };

  const onEditingStart = (e) => {
    setEditRowKey(e.key);
  };

  const onEditCanceled = (e) => {
    setEditRowKey(null);
  };

  const onRowPrepared = (e) => {
    if (e.node.hasChildren) {
      e.rowElement.classList.add("parentRow");
    }
  };

  return (
    <React.Fragment>
      {/* <Toolbar>
        <Item location={"before"}>
          <span
            style={{ fontWeight: 500, color: "#009688", marginLeft: "10px" }}
          >
            DIVISION LIST
          </span>
        </Item>
      </Toolbar> */}
      <TreeList
        keyExpr="div"
        parentIdExpr={"uDiv"}
        dataSource={divDataSource}
        hoverStateEnabled={true}
        showBorders={true}
        showColumnHeaders={false}
        showColumnLines={true}
        autoExpandAll={true}
        height={"100%"}
        style={{
          maxHeight: "calc(100vh - 145px)",
        }}
        onSelectionChanged={onSelectionChanged}
        onEditingStart={onEditingStart}
        onEditCanceled={onEditCanceled}
        onRowPrepared={onRowPrepared}
      >
        <Scrolling mode={"virtual"} showScrollbar="always" />

        <Selection mode={"single"} />

        <StateStoring
          enabled={true}
          type="localStorage"
          storageKey={"Organization.DivisionList"}
        />

        {canEditDiv && (
          <Editing
            allowUpdating={true}
            allowDeleting={true}
            allowAdding={true}
            // popup={{
            //   title: "Division Info.",
            //   showTitle: true,
            //   width: 700,
            // }}
            mode="popup"
          >
            <Texts
              confirmDeleteTitle={"Delete the Division"}
              confirmDeleteMessage={
                "Are you sure you want to delete this division?"
              }
            />
            <Popup
              title={"DIVISION INFO."}
              showTitle={true}
              // width="1200"
              height={200}
              // hideOnOutsideClick={true}
              // dragEnabled={false}
              // showCloseButton={true}
            />
            <Form
              labelMode="outside"
              showColonAfterLabel={false}
              labelLocation={"top"}
              minColWidth={300}
              colCount={2}
              colCountByScreen={{ sm: 2, md: 4 }}
              screenByWidth={(width) => {
                return width < 720 ? "sm" : "md";
              }}
              validationGroup="employee"
              height={"100%"}
            >
              <SimpleItem
                dataField={"div"}
                editorType="dxTextBox"
                editorOptions={{ showClearButton: true }}
              >
                <RequiredRule message={"This division field is required."} />
                <StringLengthRule
                  max={3}
                  message="The division field must be a string wigh a max length of 3."
                />
                <AsyncRule
                  message={"Division is already registered."}
                  validationCallback={validationCallback}
                />
              </SimpleItem>
              <SimpleItem
                dataField={"name"}
                colSpan={2}
                editorType="dxTextBox"
                editorOptions={{ showClearButton: true }}
              >
                <RequiredRule message={"This name field is required."} />
              </SimpleItem>
              <SimpleItem
                dataField={"uDiv"}
                editorOptions={{ showClearButton: true }}
              ></SimpleItem>
            </Form>
          </Editing>
        )}

        <Column dataField={"div"} width={150} caption="Division"></Column>
        <Column dataField={"name"} caption="Name" />
        <Column dataField={"uDiv"} visible={false} caption="Upper Division">
          <Lookup dataSource={div} displayExpr="name" valueExpr={"id"} />
        </Column>
        {canEditDiv && (
          <Column type={"buttons"}>
            <Button name="edit" />
            <Button name="delete" />
          </Column>
        )}

        <Toolbar>
          <Item location={"before"}>
            <span
              style={{ fontWeight: 500, color: "#009688", marginLeft: "10px" }}
            >
              DIVISION LIST
            </span>
          </Item>
          <Item location={"after"} name="addRowButton"></Item>
        </Toolbar>
      </TreeList>
    </React.Fragment>
  );
}
